import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Observable } from 'rxjs';

export interface VisitServiceInput {
  id: number;
  count: number;
  unitPrice: number;
}

export interface CreateContactRequest {
  name: string;
  email: string;
  phoneNumber: string;
  message?: string;
  apartmentId?: number;
  services: VisitServiceInput[];
  reserved: boolean;
  reservationValue?: string;
  skipScheduling?: boolean;
}

export interface CreateContactResponse {
  opportunityId: number;
  scheduleToken: string;
  message: string;
}

export interface ScheduleVisitRequest {
  visitDate: string;
  scheduleToken: string;
}

export interface ScheduleVisitResponse {
  message: string;
}

export interface VerifyVisitRequest {
  sessionToken: string;
  verificationCode: number;
}

export interface VerifyVisitResponse {
  message: string;
}

export interface VisitAvailabilityResponse {
  occupiedSlots: string[];
}

@Injectable({
  providedIn: 'root',
})
export class AppointmentService {
  private readonly apiService = inject(ApiService);

  createContact(request: CreateContactRequest): Observable<CreateContactResponse> {
    return this.apiService.post<CreateContactResponse>('/appointment/contact/create', request);
  }

  scheduleVisit(
    opportunityId: number,
    request: ScheduleVisitRequest,
  ): Observable<ScheduleVisitResponse> {
    return this.apiService.patch<ScheduleVisitResponse>(
      `/appointment/visit/${opportunityId}/schedule`,
      request,
    );
  }

  verifyVisit(request: VerifyVisitRequest): Observable<VerifyVisitResponse> {
    return this.apiService.post<VerifyVisitResponse>('/opportunity/visit/verify', request);
  }

  getVisitAvailability(date: string): Observable<VisitAvailabilityResponse> {
    return this.apiService.post<VisitAvailabilityResponse>(
      '/opportunity/visit/availability',
      { date },
    );
  }
}
